import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { observer } from "mobx-react-lite";

import AppFooter from "../components/layout/AppFooter";
import AppHeader from "../components/layout/AppHeader";
import { userStore } from "../stores/userStore";

import "./PublicLayout.css";

export const PublicLayout = observer(function PublicLayout() {
  useEffect(() => {
    userStore.load();
  }, []);

  return (
    <div className="public-layout">
      <AppHeader minimal={!userStore.authed} />
      <main className="public-layout__content">
        <Outlet />
      </main>
      <AppFooter />
    </div>
  );
});
